import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeService, setActiveService] = useState<number | null>(null);
  const [showPhoneMenu, setShowPhoneMenu] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const services = [
    {
      icon: 'ri-shield-user-line',
      title: 'Gardiennage Expert',
      description: 'Personnel qualifié et formé pour assurer la surveillance permanente de vos locaux avec professionnalisme et rigueur.'
    },
    {
      icon: 'ri-footprint-line',
      title: 'Maîtres-Chiens',
      description: 'Équipes cynophiles spécialisées pour une protection renforcée contre les intrusions et menaces potentielles.'
    },
    {
      icon: 'ri-camera-line',
      title: 'Vidéosurveillance',
      description: 'Installation et gestion de systèmes de surveillance électronique de dernière génération pour une sécurité optimale.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Protection Rapprochée',
      description: 'Service de protection personnelle pour les personnes nécessitant une sécurité individuelle renforcée et discrète.'
    },
    {
      icon: 'ri-car-line',
      title: 'Chauffeurs Sécurisés',
      description: 'Chauffeurs personnels formés aux techniques de sécurité pour vos déplacements en toute tranquillité.'
    },
    {
      icon: 'ri-plant-line',
      title: 'Entretien Paysager',
      description: 'Service de tonte de gazon et entretien des espaces verts pour maintenir vos propriétés impeccables.'
    }
  ];

  const stats = [
    { number: '15+', label: 'Ans d\'Expérience', icon: 'ri-time-line' },
    { number: 'Nombreux', label: 'Clients Satisfaits', icon: 'ri-shield-star-line' },
    { number: '24/7', label: 'Surveillance Continue', icon: 'ri-eye-line' },
    { number: '100%', label: 'Satisfaction Client', icon: 'ri-thumb-up-line' }
  ];

  return (
    <div className="min-h-screen bg-white font-sans">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className={`rounded-xl p-2 transition-all duration-300 ${isScrolled ? 'bg-transparent' : 'bg-white'}`}>
                <img 
                  src="https://static.readdy.ai/image/a9a439cd81eb46655b63bc45d4712c19/2ce1992146e1d56483e36d50883fb39e.jpeg" 
                  alt="PROMPT SÉCURITÉ Logo" 
                  className="h-20 w-auto"
                />
              </div>
            </div>
            
            <div className="hidden md:flex items-center space-x-8">
              <a href="#accueil" className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-900 hover:text-yellow-500' : 'text-white hover:text-yellow-400'}`}>
                Accueil
              </a>
              <a href="#apropos" className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-900 hover:text-yellow-500' : 'text-white hover:text-yellow-400'}`}>
                À Propos
              </a>
              <a href="#services" className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-900 hover:text-yellow-500' : 'text-white hover:text-yellow-400'}`}>
                Services
              </a>
              <a href="#contact" className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-900 hover:text-yellow-500' : 'text-white hover:text-yellow-400'}`}>
                Contact
              </a>
              <div className="relative">
                <button 
                  onClick={() => setShowPhoneMenu(!showPhoneMenu)}
                  className="bg-yellow-500 text-black px-6 py-3 rounded-full font-bold text-sm hover:bg-yellow-400 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line"></i>
                  Appelez-nous
                  <i className={`ri-arrow-down-s-line transition-transform ${showPhoneMenu ? 'rotate-180' : ''}`}></i>
                </button>
                
                {showPhoneMenu && (
                  <div className="absolute top-full right-0 mt-2 bg-white rounded-xl shadow-2xl py-3 min-w-[280px] border border-gray-100">
                    <a 
                      href="tel:+2252520006946" 
                      className="flex items-center gap-3 px-5 py-3 hover:bg-yellow-50 transition-colors cursor-pointer"
                    >
                      <i className="ri-phone-line text-yellow-600"></i>
                      <span className="text-gray-900 font-medium text-sm">+225 25 20 00 69 46</span>
                    </a>
                    <a 
                      href="tel:+2250711996898" 
                      className="flex items-center gap-3 px-5 py-3 hover:bg-yellow-50 transition-colors cursor-pointer"
                    >
                      <i className="ri-phone-line text-yellow-600"></i>
                      <span className="text-gray-900 font-medium text-sm">+225 07 11 99 68 98</span>
                    </a>
                    <a 
                      href="tel:+2250778345964" 
                      className="flex items-center gap-3 px-5 py-3 hover:bg-yellow-50 transition-colors cursor-pointer"
                    >
                      <i className="ri-phone-line text-yellow-600"></i>
                      <span className="text-gray-900 font-medium text-sm">+225 07 78 34 59 64</span>
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="accueil" className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/b08280a3d90c33de2999cfe7af9edf48.jpg" 
            alt="PROMPT SÉCURITÉ Agents avec logo" 
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 text-left w-full">
          <div className="max-w-3xl">
            <div className="inline-block border border-yellow-400 rounded-full px-6 py-2 mb-6 backdrop-blur-sm bg-white/5">
              <span className="text-white text-sm font-medium tracking-wider">DEPUIS 2009 • SÉCURITÉ INTÉGRALE</span>
            </div>
            
            <h1 className="text-7xl font-bold mb-6 leading-tight">
              <span className="text-white block" style={{ fontFamily: 'Montserrat, sans-serif' }}>VOTRE SÉCURITÉ</span>
              <span className="text-yellow-400 block italic" style={{ fontFamily: 'Playfair Display, serif' }}>Notre Priorité</span>
            </h1>
            
            <p className="text-white text-2xl mb-10 font-light">
              Protection professionnelle 24/7 en Côte d'Ivoire
            </p>
            
            <div className="flex gap-5">
              <a 
                href="#contact" 
                className="bg-yellow-500 text-black px-10 py-4 rounded-full font-bold text-lg hover:bg-yellow-400 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
              >
                Demander un Devis
              </a>
              <a 
                href="#services" 
                className="border-2 border-white text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-black transition-all whitespace-nowrap cursor-pointer"
              >
                Nos Services
              </a>
            </div>
            
            <div className="mt-12 flex flex-wrap gap-4">
              <a 
                href="tel:+2252520006946" 
                className="flex items-center gap-2 text-white hover:text-yellow-400 transition-colors cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                <span className="text-sm font-medium">+225 25 20 00 69 46</span>
              </a>
              <span className="text-white/50">•</span>
              <a 
                href="tel:+2250711996898" 
                className="flex items-center gap-2 text-white hover:text-yellow-400 transition-colors cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                <span className="text-sm font-medium">+225 07 11 99 68 98</span>
              </a>
              <span className="text-white/50">•</span>
              <a 
                href="tel:+2250778345964" 
                className="flex items-center gap-2 text-white hover:text-yellow-400 transition-colors cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                <span className="text-sm font-medium">+225 07 78 34 59 64</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* À Propos Section */}
      <section id="apropos" className="py-32 bg-gradient-to-br from-amber-50 to-orange-50 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-1/3 h-full opacity-10">
          <svg viewBox="0 0 200 200" className="w-full h-full">
            <path d="M 0,100 Q 50,50 100,100 T 200,100" stroke="#FFD700" strokeWidth="2" fill="none"/>
          </svg>
        </div>

        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 items-center">
            <div className="lg:col-span-2">
              <p className="text-gray-500 text-sm font-semibold tracking-widest mb-4">QUI SOMMES-NOUS</p>
              <h2 className="text-5xl font-bold mb-6 leading-tight">
                <span className="text-gray-900 block" style={{ fontFamily: 'Merriweather, serif' }}>Cadres Ivoiriens</span>
                <span className="text-gray-900 block" style={{ fontFamily: 'Merriweather, serif' }}>Dynamiques &</span>
                <span className="text-yellow-600 block italic" style={{ fontFamily: 'Playfair Display, serif' }}>Dévoués</span>
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed">
                Depuis octobre 2009, PROMPT SÉCURITÉ est l'œuvre de cadres ivoiriens dynamiques qui ont une seule mission : garantir votre tranquillité. En tant que Société à Responsabilité Limitée (SARL), nous ne faisons pas que surveiller, nous offrons une sécurité intégrale adaptée à tous vos besoins.
              </p>
            </div>

            <div className="lg:col-span-3">
              <div className="grid grid-cols-2 gap-6">
                {stats.map((stat, index) => (
                  <div 
                    key={index}
                    className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
                  >
                    <div className="flex items-center justify-center w-16 h-16 bg-yellow-100 rounded-full mb-4">
                      <i className={`${stat.icon} text-3xl text-yellow-600`}></i>
                    </div>
                    <div className="text-5xl font-bold text-gray-900 mb-2">{stat.number}</div>
                    <div className="text-gray-600 text-sm font-medium">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <p className="text-gray-500 text-sm font-semibold tracking-widest mb-4">NOS SERVICES</p>
            <h2 className="text-6xl font-bold mb-6">
              <span className="text-gray-900">Protection </span>
              <span className="text-yellow-500 italic" style={{ fontFamily: 'Playfair Display, serif' }}>Complète</span>
            </h2>
            <p className="text-gray-600 text-xl">Solutions de sécurité adaptées à vos besoins</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, index) => (
              <div 
                key={index}
                onMouseEnter={() => setActiveService(index)}
                onMouseLeave={() => setActiveService(null)}
                className={`bg-white border rounded-3xl p-10 transition-all duration-300 cursor-pointer ${
                  activeService === index 
                    ? 'border-yellow-500 shadow-2xl -translate-y-2' 
                    : 'border-gray-200 shadow-md hover:shadow-lg'
                }`}
              >
                <div className="flex items-center justify-center w-20 h-20 bg-yellow-50 rounded-full mb-6">
                  <i className={`${service.icon} text-4xl text-gray-700`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
                <p className="text-gray-600 text-base leading-relaxed mb-6">{service.description}</p>
                <a href="#contact" className="text-yellow-600 font-semibold text-sm flex items-center gap-2 hover:gap-3 transition-all cursor-pointer">
                  En savoir plus <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA Section */}
      <section id="contact" className="py-32 bg-gradient-to-br from-amber-50 to-orange-50">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <div className="mb-12 rounded-3xl overflow-hidden shadow-2xl">
            <img 
              src="https://readdy.ai/api/search-image?query=Professional%20African%20security%20team%20in%20yellow%20and%20grey%20uniforms%20with%20PROMPT%20SECURITE%20logo%20badges%20patches%20on%20their%20chest%20standing%20proudly%20together%20in%20front%20of%20security%20patrol%20vehicle%2C%20group%20of%20security%20guards%20with%20dark%20skin%20wearing%20official%20uniforms%20with%20visible%20company%20logo%20emblems%2C%20corporate%20security%20company%20professional%20team%20portrait%20photo%2C%20modern%20white%20security%20van%20with%20company%20branding%2C%20daytime%20outdoor%20setting%20bright%20natural%20lighting%2C%20high%20quality%20professional%20photography%20confident%20security%20personnel%20in%20formation&width=1400&height=600&seq=contact-ps-logo-team-002&orientation=landscape" 
              alt="Équipe PROMPT SÉCURITÉ avec logo" 
              className="w-full h-auto object-cover object-top"
              style={{ maxHeight: '400px' }}
            />
          </div>

          <div className="mb-10">
            <h2 className="text-5xl leading-tight mb-2">
              <span className="text-gray-700 font-normal">Prêt à sécuriser </span>
              <span className="text-gray-900 font-bold italic" style={{ fontFamily: 'Playfair Display, serif' }}>votre espace ?</span>
            </h2>
            <p className="text-gray-700 text-4xl font-normal">Contactez-nous dès maintenant</p>
          </div>

          <div className="flex flex-wrap justify-center gap-4 mb-12">
            <a 
              href="tel:+2252520006946" 
              className="inline-flex items-center gap-3 bg-gray-900 text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-yellow-500 hover:text-black transition-all shadow-xl hover:shadow-2xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line text-xl"></i>
              +225 25 20 00 69 46
            </a>
            <a 
              href="tel:+2250711996898" 
              className="inline-flex items-center gap-3 bg-gray-900 text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-yellow-500 hover:text-black transition-all shadow-xl hover:shadow-2xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line text-xl"></i>
              +225 07 11 99 68 98
            </a>
            <a 
              href="tel:+2250778345964" 
              className="inline-flex items-center gap-3 bg-gray-900 text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-yellow-500 hover:text-black transition-all shadow-xl hover:shadow-2xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line text-xl"></i>
              +225 07 78 34 59 64
            </a>
          </div>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-center justify-center w-16 h-16 bg-yellow-100 rounded-full mx-auto mb-4">
                <i className="ri-map-pin-line text-3xl text-yellow-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Adresse</h3>
              <p className="text-gray-600">Boulevard Liberté<br/>À 200m du rond-point<br/>Abidjan, Côte d'Ivoire</p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-center justify-center w-16 h-16 bg-yellow-100 rounded-full mx-auto mb-4">
                <i className="ri-phone-line text-3xl text-yellow-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Téléphones</h3>
              <p className="text-gray-600">
                <a href="tel:+2252520006946" className="hover:text-yellow-600 transition-colors cursor-pointer">+225 25 20 00 69 46</a><br/>
                <a href="tel:+2250711996898" className="hover:text-yellow-600 transition-colors cursor-pointer">+225 07 11 99 68 98</a><br/>
                <a href="tel:+2250778345964" className="hover:text-yellow-600 transition-colors cursor-pointer">+225 07 78 34 59 64</a>
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-center justify-center w-16 h-16 bg-yellow-100 rounded-full mx-auto mb-4">
                <i className="ri-mail-line text-3xl text-yellow-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Email</h3>
              <p className="text-gray-600">
                <a href="mailto:info@promptsecurite.com" className="hover:text-yellow-600 transition-colors cursor-pointer">info@promptsecurite.com</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white pt-20 pb-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
            <div>
              <div className="bg-white rounded-xl p-3 inline-block mb-6">
                <img 
                  src="https://static.readdy.ai/image/a9a439cd81eb46655b63bc45d4712c19/2ce1992146e1d56483e36d50883fb39e.jpeg" 
                  alt="PROMPT SÉCURITÉ" 
                  className="h-20 w-auto"
                />
              </div>
              <p className="text-gray-400 text-sm leading-relaxed">
                Votre partenaire de confiance pour une sécurité intégrale en Côte d'Ivoire depuis 2009.
              </p>
            </div>

            <div>
              <h4 className="text-gray-300 text-xs font-semibold tracking-widest mb-6">NAVIGATION</h4>
              <ul className="space-y-4">
                <li><a href="#accueil" className="text-white hover:text-yellow-400 transition-colors text-sm cursor-pointer">Accueil</a></li>
                <li><a href="#services" className="text-white hover:text-yellow-400 transition-colors text-sm cursor-pointer">Services</a></li>
                <li><a href="#apropos" className="text-white hover:text-yellow-400 transition-colors text-sm cursor-pointer">À Propos</a></li>
                <li><a href="#contact" className="text-white hover:text-yellow-400 transition-colors text-sm cursor-pointer">Contact</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-gray-300 text-xs font-semibold tracking-widest mb-6">SERVICES</h4>
              <ul className="space-y-4">
                <li className="text-gray-400 text-sm">Gardiennage</li>
                <li className="text-gray-400 text-sm">Maîtres-Chiens</li>
                <li className="text-gray-400 text-sm">Vidéosurveillance</li>
                <li className="text-gray-400 text-sm">Protection Rapprochée</li>
                <li className="text-gray-400 text-sm">Chauffeurs Sécurisés</li>
              </ul>
            </div>

            <div>
              <h4 className="text-gray-300 text-xs font-semibold tracking-widest mb-6">CONTACT</h4>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <i className="ri-map-pin-line text-yellow-400 text-lg mt-1"></i>
                  <span className="text-gray-400 text-sm">Boulevard Liberté, à 200m du rond-point</span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-phone-line text-yellow-400 text-lg"></i>
                  <a href="tel:+2252520006946" className="text-gray-400 text-sm hover:text-yellow-400 transition-colors cursor-pointer">+225 25 20 00 69 46</a>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-mail-line text-yellow-400 text-lg"></i>
                  <a href="mailto:info@promptsecurite.com" className="text-gray-400 text-sm hover:text-yellow-400 transition-colors cursor-pointer">info@promptsecurite.com</a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-700 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-gray-400 text-sm">© 2025 Prompt Sécurité. Tous droits réservés.</p>
              <p className="text-gray-500 text-xs">
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors cursor-pointer">Website Builder</a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
